import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { ModalAction, SaleAction } from '../../store/actions';

class Invoice extends PureComponent {
  static propTypes = {
    getSale: PropTypes.func,
    openModal: PropTypes.func,
    permissions: PropTypes.arrayOf(PropTypes.string),
    sale: PropTypes.object,
    saleId: PropTypes.number,
  };

  constructor(props) {
    super(props);
    this.ref = React.createRef();
  }

  componentDidMount() {
    this.props.getSale(this.props.saleId);
  }

  handlePrint(event) {
    const _window = window.open();
    _window.document.write(
      '<style>*{box-sizing:border-box;line-height:1.5;margin:0;padding:0;}</style>',
    );
    _window.document.write(this.ref.current.innerHTML);
  }

  render() {
    return (
      <div className="row">
        <div className="col-12">
          <button
            className="btn btn-primary btn-sm"
            onClick={this.handlePrint.bind(this)}
            type="button"
          >
            Print
          </button>
          {(this.props.permissions?.includes?.('sale.custom_edit') ||
            (this.props.permissions?.includes?.('sale.custom_edit_once') &&
              !this.props.sale?.custom_id &&
              !this.props.sale?.custom_price &&
              !this.props.sale?.custom_sold_at)) && (
            <button
              className="btn btn-info btn-sm ml-1"
              onClick={() => this.props.openModal(this.props.sale)}
              type="button"
            >
              Custom Edit
            </button>
          )}
        </div>
        <div className="col-12">
          <div
            ref={this.ref}
            style={{
              height: 42 * 0.5 + 'cm',
              width: 59 * 0.5 + 'cm',
            }}
          >
            <div
              style={{
                height: 10 * 0.5 + 'cm',
                paddingLeft: 39 * 0.5 + 'cm',
                paddingRight: 3 * 0.5 + 'cm',
                paddingTop: 4.5 * 0.5 + 'cm',
                textTransform: 'uppercase',
                width: 59 * 0.5 + 'cm',
              }}
            >
              <p
                style={{
                  marginBottom: 0,
                }}
              >
                {this.props.sale?.customer?.name}
              </p>
              <p
                style={{
                  marginBottom: 0.5 * 0.5 + 'cm',
                }}
              >
                {this.props.sale?.customer?.father_name}
              </p>
              <p
                style={{
                  marginBottom: 0,
                }}
              >
                {this.props.sale?.customer?.address}
              </p>
            </div>
            <div
              style={{
                height: 3 * 0.5 + 'cm',
                paddingLeft: 42 * 0.5 + 'cm',
                paddingRight: 3 * 0.5 + 'cm',
                paddingTop: 1 * 0.5 + 'cm',
                textTransform: 'uppercase',
                width: 59 * 0.5 + 'cm',
              }}
            >
              <p
                style={{
                  marginBottom: 0,
                  paddingLeft: 3 * 0.5 + 'cm',
                }}
              >
                {this.props.sale?.custom_id}
              </p>
              <p
                style={{
                  marginBottom: 0,
                  paddingTop: 0.25 * 0.5 + 'cm',
                }}
              >
                {this.props.sale?.custom_sold_at}
              </p>
            </div>
            <div
              style={{
                display: 'flex',
                height: 12 * 0.5 + 'cm',
                paddingLeft: 6 * 0.5 + 'cm',
                paddingRight: 2 * 0.5 + 'cm',
                paddingTop: 4 * 0.5 + 'cm',
                textTransform: 'uppercase',
                width: 59 * 0.5 + 'cm',
              }}
            >
              <div
                style={{
                  height: 9 * 0.5 + 'cm',
                  paddingLeft: 1 * 0.5 + 'cm',
                  paddingRight: 1 * 0.5 + 'cm',
                  width: 7 * 0.5 + 'cm',
                }}
              >
                <p
                  style={{
                    marginBottom: 0,
                  }}
                >
                  {this.props.sale?.purchase?.chassis_number?.slice?.(-5)}
                </p>
              </div>
              <div
                style={{
                  height: 9 * 0.5 + 'cm',
                  paddingLeft: 1 * 0.5 + 'cm',
                  paddingRight: 1 * 0.5 + 'cm',
                  width: 5 * 0.5 + 'cm',
                }}
              >
                <p
                  style={{
                    marginBottom: 0,
                  }}
                >
                  {this.props.sale?.purchase?.engine_number?.slice?.(-5)}
                </p>
              </div>
              <div
                style={{
                  height: 9 * 0.5 + 'cm',
                  paddingLeft: 1 * 0.5 + 'cm',
                  paddingRight: 1 * 0.5 + 'cm',
                  width: 7 * 0.5 + 'cm',
                }}
              >
                <p
                  style={{
                    marginBottom: 0,
                  }}
                >
                  {this.props.sale?.purchase?.color?.name}
                </p>
              </div>
              <div
                style={{
                  height: 9 * 0.5 + 'cm',
                  paddingLeft: 0.75 * 0.5 + 'cm',
                  paddingRight: 0.75 * 0.5 + 'cm',
                  width: 3.5 * 0.5 + 'cm',
                }}
              >
                <p
                  style={{
                    marginBottom: 0,
                  }}
                >
                  01
                </p>
              </div>
              <div
                style={{
                  height: 9 * 0.5 + 'cm',
                  paddingLeft: 1 * 0.5 + 'cm',
                  paddingRight: 1 * 0.5 + 'cm',
                  width: 12 * 0.5 + 'cm',
                }}
              >
                <p
                  style={{
                    marginBottom: 0,
                  }}
                >
                  {this.props.sale?.purchase?.vehicle?.model}{' '}
                  {this.props.sale?.purchase?.vehicle?.class}
                </p>
              </div>
              <div
                style={{
                  height: 9 * 0.5 + 'cm',
                  paddingLeft: 1 * 0.5 + 'cm',
                  paddingRight: 1 * 0.5 + 'cm',
                  width: 6.5 * 0.5 + 'cm',
                }}
              >
                <p
                  style={{
                    marginBottom: 0,
                  }}
                >
                  {this.props.sale?.custom_price}
                </p>
              </div>
              <div
                style={{
                  height: 9 * 0.5 + 'cm',
                  paddingLeft: 1 * 0.5 + 'cm',
                  paddingRight: 1 * 0.5 + 'cm',
                  width: 11 * 0.5 + 'cm',
                }}
              >
                <p
                  style={{
                    marginBottom: 0,
                  }}
                >
                  {this.props.sale?.custom_price}
                </p>
              </div>
            </div>
            <div
              style={{
                height: 5 * 0.5 + 'cm',
                paddingLeft: 46 * 0.5 + 'cm',
                paddingRight: 3 * 0.5 + 'cm',
                paddingTop: 0.25 * 0.5 + 'cm',
                textTransform: 'uppercase',
                width: 59 * 0.5 + 'cm',
              }}
            >
              <p
                style={{
                  marginBottom: 0,
                }}
              >
                {this.props.sale?.custom_price}
              </p>
            </div>
            <div
              style={{
                height: 6 * 0.5 + 'cm',
                paddingLeft: 8 * 0.5 + 'cm',
                paddingRight: 26 * 0.5 + 'cm',
                paddingTop: 1 * 0.5 + 'cm',
                textTransform: 'uppercase',
                width: 59 * 0.5 + 'cm',
              }}
            >
              <p
                style={{
                  marginBottom: 0,
                }}
              >
                {this.props.sale?.custom_price}
              </p>
              <p
                style={{
                  marginBottom: 0,
                }}
              >
                {this.props.sale?.custom_price_in_words} TAKA ONLY
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => ({
  permissions: state?.auth?.permissions,
  sale: state?.sale?.detail,
  saleId: Number(props?.match?.params?.id),
});

const mapDispatchToProps = dispatch => ({
  getSale: id => dispatch(SaleAction.getSale(id)),
  openModal: data =>
    dispatch(ModalAction.openModal({ data, name: 'EditCustomSale' })),
});

export default connect(mapStateToProps, mapDispatchToProps)(Invoice);
